import type { TabAction } from '@core/core/types'
import { IconAddTab } from '@core/icons'
import { Show } from '@library/components'
import { getIconByType } from '@library/model'
import type { FC } from 'react'

import { Tab } from '../Tab'
import css from './Tabs.css'
import type { Props } from './types'

export const Tabs: FC<Props> = ({
  tabs,
  selectedTabId,
  onTabChange,
  onCloseTab,
  onCloseOther,
  onDuplicate,
  onPin,
  onShowModal,
  isWorkAreaActive,
}) => {
  const onChangeHandler = (tabAction: TabAction) => {
    const { actionType, tabId } = tabAction
    switch (actionType) {
      case 'set':
        onTabChange(tabId)
        break
      case 'close':
        onCloseTab(tabId)
        break
      case 'closeOther':
        onCloseOther(tabId)
        break
      case 'duplicate':
        onDuplicate(tabId)
        break
      case 'pin':
        onPin(tabId)
        break
    }
  }

  return (
    <div className={css.container} data-testid="tabs">
      {tabs.map(({ id, type, displayName }) => (
        <Tab
          key={id}
          id={id}
          isWorkAreaActive={isWorkAreaActive}
          label={displayName}
          selected={id === selectedTabId}
          icon={getIconByType(type)}
          onChange={onChangeHandler}
        />
      ))}
      <Show when={tabs.length}>
        <span className={css.icon} data-testid="tabs__btn_show" onClick={onShowModal}>
          <IconAddTab size="xs" />
        </span>
      </Show>
    </div>
  )
}
